import React from 'react';
import Img from '../../images/404.png';

interface NotFoundProps {
  height?: string;
}

const NotFound = ({height = '100vh'}: NotFoundProps) => {

  return (
    <div
      style={{
        height: height,
        backgroundColor: height !== "100vh" && "#fff",
        boxShadow: height !== "100vh" && "none",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div className='empty-img-container'>
        <div style={{maxWidth: 400}}>
          <img src={Img} className='empty-img' alt='404' />
        </div>
      </div>
    </div>
  );
};

export default NotFound;